import React from "react";
import "./ThresholdBG.css";
const ThresholdBG = ({ thresholds }) => {
  if (!thresholds) return <div className="no-threshold-bg" data-testid='no-threshold-bg' />;
  const firstWidth = thresholds.min;
  const secondWidth = thresholds.max - thresholds.min;
  const thirdWidth = 100 - thresholds.max;

  const widths = [firstWidth, secondWidth, thirdWidth];

  return (
    <div className="threshold-bg" data-testid='threshold-bg' >
      {widths.map((width, index) => (
        <div key={index} style={{ width: `${width}%` }}></div>
      ))}
    </div>
  );
};
export default ThresholdBG;
